<template>
  <button type="button" class="btn btn-sm btn-outline-primary" @click="click">
    <i v-if="!opened" class="bi bi-list h2" />
    <i v-else class="bi bi-x-lg h2" />
  </button>
</template>

<script>
import eventbus from '@/modules/core/services/eventbus';

export default {
  data: () => ({ opened: false }),
  watch: {
    $route() {
      this.opened = false;
      eventbus.emit('sidebar.opened', this.opened);
    },
  },
  methods: {
    click() {
      this.opened = !this.opened;
      eventbus.emit('sidebar.opened', this.opened);
    },
  },
};
</script>
